import { useEffect, useState } from 'react'
import styles from './mobile-app-legal-footer.module.css'
import { Text } from '@cinch-labs/design-system'

//TODO: This was a copy+paste from the PD shared components. It could be moved to the shared components.
export const MobileAppLegalFooter = () => {
  const [year, setYear] = useState<number | null>(null)

  useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])

  return (
    <div
      className={styles.legalFooterContainer}
      data-testid="mobile-app-legal-footer"
    >
      <Text element="p" fontSize="s" fontWeight="bold" lineHeight="body">
        Used cars are sold by cinch cars limited.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Cinch Cars Limited is an appointed representative of Marshall Motor
        Group which is authorised and regulated by the Financial Conduct
        Authority (their registration number is 310503). Permitted activities
        include advising on and arranging general insurance contracts and acting
        as a credit broker not a lender.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        We can introduce you to a limited number of finance providers. We do not
        charge a fee for our Consumer Credit services. We do not act as a
        financial adviser, or fiduciary. We act in our own interest, whichever
        lender we introduce you to, we will typically receive commission from
        them based on either a fixed fee or a fixed percentage of the amount you
        borrow. Any and all commission amounts will be fully disclosed to you as
        part of your sales journey. You will be required to give your fully
        informed consent to our receipt of this commission. By doing this, you
        acknowledge that you understand our role as a credit broker, and that we
        will receive a financial incentive if you take out a loan from a lender
        that we introduce you to.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        All finance applications are subject to status, terms and conditions
        apply, UK residents only, 18&apos;s or over, Guarantees may be required.
      </Text>
      <Text element="p" fontSize="s" fontWeight="bold" lineHeight="body">
        New cars are sold by Marshall Motor Group, who will also arrange any
        finance for those cars.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        &copy; {year || ''} Marshall Motor Group
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Registered Office c/o Marshall Volkswagen Milton Keynes, Greyfriars
        Court, Milton Keynes, Buckinghamshire, MK10 0BN.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Registered in England Number 00295579 | VAT Reg. No: 213209019
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Marshall Motor Group Limited is authorised and regulated by the
        Financial Conduct Authority. Our Firm Reference Number is 310503.
        Details of our permissions and trading names can be checked via the FCA
        register https://register.fca.org.uk/s/
      </Text>
    </div>
  )
}
